(function () {
    'use strict';

    function projectApplicationRequestsDataService($http) {

        var baseUrl = '/api';

        function getAvaliableProjects() {
            return $http.get(baseUrl + '/applyforprojects').then(
                function (response) {
                    return response.data;
                }
            );
        };

        function createProjectApplicationRequests(data) {
            return $http.post(baseUrl = '/projectapplication', data).then(
                function (response) { return true; }
            );
        };

        return {
            getAvaliableProjects: getAvaliableProjects,
            createProjectApplicationRequests: createProjectApplicationRequests
        }
    }

    projectApplicationRequestsDataService.$inject = ['$http'];

    angular.module('ecap.crm').service('projectApplicationRequestsDataService', projectApplicationRequestsDataService);
})();
